import { Pagination as PaginationBase } from '@uaveiro/ui';
import { withPortalProviders } from 'modules/utils';
import styled from 'styled-components/macro'

const locale = {
  items_per_page: 'itens por página',
  jump_to: 'ir para',
  jump_to_confirm: 'confirmar',
  page: 'página',
  next_page: 'próxima página',
  prev_page: 'página anterior',
  prev_5: 'cinco anteriores',
  next_5: 'cinco próximos',
  prev_3: 'três anteriores',
  next_3: 'três seguintes',
}

// TEMP Fix, waiting for answer here:
// https://github.com/react-component/pagination/pull/80#discussion_r414526869

const Pagination = (props) => withPortalProviders(
  PaginationBase,
  { locale, showTitle: false, ...props }
)

export default styled(Pagination)`
  min-height: 20px;
  .rc-pagination {
    font-size: ${props => props.theme.sizes.s};
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    padding: 0;
  }
  .rc-pagination > li {
    list-style: none;
  }
  .rc-pagination-total-text {
    float: left;
    height: 30px;
    line-height: 30px;
    list-style: none;
    padding: 0;
    margin: 0 8px 0 0;
  }
  .rc-pagination:after {
    content: " ";
    display: block;
    height: 0;
    clear: both;
    overflow: hidden;
    visibility: hidden;
  }
  .rc-pagination-item {
    cursor: pointer;
    min-width: 16px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    list-style: none;
    float: left;
    background-color: transparent;
    margin-right: 8px;
  }
  .rc-pagination-item a {
    text-decoration: none;
    color: ${props => props.theme.components.pagination.linkColor};
    font-size: ${props => props.theme.sizes.s};
  }
  .rc-pagination-item:hover {
    color: ${props => props.mainColor
      || props.theme.components.pagination.linkHoverColor};
  }
  .rc-pagination-item:hover a {
    color: ${props => props.mainColor
      || props.theme.components.pagination.linkHoverColor};
  }
  .rc-pagination-item-disabled {
    cursor: not-allowed;
  }
  .rc-pagination-item-disabled:hover {
    color: ${props => props.theme.components.pagination.disabledHover};
  }
  .rc-pagination-item-disabled:hover a {
    color: ${props => props.theme.components.pagination.disabledHover};
  }
  .rc-pagination-item-active {
    color: ${props => props.mainColor
      || props.theme.components.pagination.linkActive};
  }
  .rc-pagination-item-active a {
    color: ${props => props.mainColor
      || props.theme.components.pagination.linkActive};
  }
  .rc-pagination-item-active:hover a {
    color: ${props => props.mainColor
      || props.theme.components.pagination.linkActive};
  }
  .rc-pagination-jump-prev:after,
  .rc-pagination-jump-next:after {
    content: "•••";
    display: block;
    letter-spacing: 2px;
    color: ${props => props.theme.components.pagination.jumpNextColor};
    font-size: ${props => props.theme.sizes.s};
    margin-top: 1px;
  }
  .rc-pagination-jump-prev:hover:after,
  .rc-pagination-jump-next:hover:after {
    color: ${props => props.mainColor
      || props.theme.components.pagination.jumpNextHoverColor};
  }
  .rc-pagination-jump-prev:hover:after {
    content: "«";
  }
  .rc-pagination-jump-next:hover:after {
    content: "»";
  }
  .rc-pagination-jump-prev-custom-icon,
  .rc-pagination-jump-next-custom-icon {
    position: relative;
  }
  .rc-pagination-jump-prev-custom-icon:after,
  .rc-pagination-jump-next-custom-icon:after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    margin: auto;
    transition: all 0.2s;
    content: "•••";
    opacity: 1;
    display: block;
    letter-spacing: 2px;
    color: ${props => props.theme.components.pagination.jumpNextColor};
    font-size: ${props => props.theme.sizes.s};
    margin-top: 1px;
  }
  .rc-pagination-jump-prev-custom-icon .custom-icon-jump-prev,
  .rc-pagination-jump-next-custom-icon .custom-icon-jump-prev,
  .rc-pagination-jump-prev-custom-icon .custom-icon-jump-next,
  .rc-pagination-jump-next-custom-icon .custom-icon-jump-next {
    opacity: 0;
    transition: all 0.2s;
  }
  .rc-pagination-jump-prev-custom-icon:hover:after,
  .rc-pagination-jump-next-custom-icon:hover:after {
    opacity: 0;
    color: ${props => props.theme.components.pagination.jumpNextColor};
  }
  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-prev,
  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-prev,
  .rc-pagination-jump-prev-custom-icon:hover .custom-icon-jump-next,
  .rc-pagination-jump-next-custom-icon:hover .custom-icon-jump-next {
    opacity: 1;
    color: ${props => props.mainColor
      || props.theme.components.pagination.jumpNextHoverColor};
  }
  .rc-pagination-prev,
  .rc-pagination-jump-prev,
  .rc-pagination-jump-next {
    margin-right: 8px;
  }
  .rc-pagination-prev,
  .rc-pagination-next,
  .rc-pagination-jump-prev,
  .rc-pagination-jump-next {
    cursor: pointer;
    color: ${props => props.theme.components.pagination.jumpPrevColor};
    font-size: ${props => props.theme.sizes.s};
    list-style: none;
    min-width: 28px;
    height: 28px;
    line-height: 28px;
    float: left;
    text-align: center;
  }
  .rc-pagination-prev a:after {
    content: "‹";
    display: block;
  }
  .rc-pagination-next a:after {
    content: "›";
    display: block;
  }
  .rc-pagination-prev,
  .rc-pagination-next {
    font-size: 18px;
    &:focus {
      outline: none;
    }
  }
  .rc-pagination-prev a,
  .rc-pagination-next a {
    color: ${props => props.theme.components.pagination.jumpPrevColor};
  }
  .rc-pagination-prev a:after,
  .rc-pagination-next a:after {
    margin-top: -1px;
  }
  .rc-pagination-disabled {
    cursor: not-allowed;
  }
  .rc-pagination-disabled a {
    color: ${props => props.theme.components.pagination.disabledLinkColor};
  }
  .rc-pagination-options {
    float: left;
    margin-left: 15px;
  }
  .rc-pagination-options-size-changer {
    float: left;
    width: 80px;
  }
  .rc-pagination-options-quick-jumper {
    float: left;
    margin-left: 16px;
    height: 28px;
    line-height: 28px;
  }
  .rc-pagination-options-quick-jumper input {
    margin: 0 8px;
    box-sizing: border-box;
    background-color: ${props => props.theme.components.pagination.quickJumperInputBgColor};
    outline: none;
    padding: 3px 12px;
    width: 50px;
    height: 28px;
  }
  .rc-pagination-options-quick-jumper input:hover {
    color: ${props => props.mainColor
      || props.theme.components.pagination.quickJumperInputHoverColor};
  }
  .rc-pagination-options-quick-jumper button {
    display: inline-block;
    margin: 0 8px;
    font-weight: 500;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    white-space: nowrap;
    padding: 0 15px;
    font-size: ${props => props.theme.sizes.s};
    height: 28px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    color: ${props => props.theme.components.pagination.quickJumperButtonColor};
    background-color: ${props => props.theme.components.pagination.quickJumperButtonBgColor};
  }
  .rc-pagination-options-quick-jumper button:hover,
  .rc-pagination-options-quick-jumper button:active,
  .rc-pagination-options-quick-jumper button:focus {
    color: ${props => props.mainColor
      || props.theme.components.pagination.quickJumperButtonHAFColor};
    background-color: ${props => props.theme.components.pagination.quickJumperButtonHAFBgColor};
    outline: none;
  }
  .rc-pagination-simple .rc-pagination-prev,
  .rc-pagination-simple .rc-pagination-next {
    border: none;
    height: 24px;
    line-height: 24px;
    margin: 0;
    font-size: 18px;
  }
  .rc-pagination-simple .rc-pagination-simple-pager {
    float: left;
    margin-right: 8px;
    list-style: none;
  }
  .rc-pagination-simple .rc-pagination-simple-pager .rc-pagination-slash {
    margin: 0 10px;
  }
  .rc-pagination-simple .rc-pagination-simple-pager input {
    margin: 0 8px;
    box-sizing: border-box;
    background-color: ${props => props.theme.components.pagination.simplePagerInputBgColor};
    outline: none;
    padding: 5px 8px;
    min-height: 20px;
  }
  .rc-pagination-simple .rc-pagination-simple-pager input:hover {
    color: ${props => props.mainColor
      || props.theme.components.pagination.simplePagerInputHoverColor};
  }
  .rc-pagination-simple .rc-pagination-simple-pager button {
    display: inline-block;
    margin: 0 8px;
    font-weight: 500;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    white-space: nowrap;
    padding: 0 8px;
    font-size: ${props => props.theme.sizes.s};
    height: 26px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    position: relative;
    color: ${props => props.theme.components.pagination.simplePagerButtonColor};
    background-color: ${props => props.theme.components.pagination.simplePagerButtonBgColor};
  }
  .rc-pagination-simple .rc-pagination-simple-pager button:hover,
  .rc-pagination-simple .rc-pagination-simple-pager button:active,
  .rc-pagination-simple .rc-pagination-simple-pager button:focus {
    color: ${props => props.mainColor
      || props.theme.components.pagination.simplePagerButtonHAFColor};
    background-color: ${props => props.theme.components.pagination.simplePagerButtonHAFBgColor};
    outline: none;
  }
  @media only screen and (max-width: 1024px) {
    .rc-pagination-item-after-jump-prev,
    .rc-pagination-item-before-jump-next {
      display: none;
    }
  }

  // Medium devices (tablets, less than 992px)
  @media (max-width: 991px) {
    .rc-pagination-item a {
      font-size: 15px;
    }

    .rc-pagination-jump-prev:after,
    .rc-pagination-jump-next:after {
      font-size: 14px;
    }

    .rc-pagination-prev,
    .rc-pagination-next {
      font-size: 22px;
    }
  }
`;
